export default "__VITE_ASSET__CNZqKw7p__"